/*
 * To use this directive in a project, you need to follow these steps:
 * 1. npm install intl-tel-input --save
 * 2. Add to angular.json  "styles": [ "node_modules/intl-tel-input/build/css/intlTelInput.css",]
 * 3. Add to angular.json "scripts": [ "node_modules/intl-tel-input/build/js/intlTelInput.min.js", ]
 * 4. The version from which utils.js is taken should preferably match the version of intl-tel-input
 * const defaultUtilScript = 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/19.2.16/js/utils.js';
 * In package.json  "intl-tel-input": "^19.2.16",
 * */
import {
    Directive,
    ElementRef,
    EventEmitter,
    HostListener,
    Inject,
    Input,
    OnInit,
    Output,
    PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
    selector: '[sbIntlTelInput]',
})
export class IntlTelInputDirective implements OnInit {
    @Input() intlTelInputOptions: { [key: string]: any } = {};

    @Output() countryChange: EventEmitter<string> = new EventEmitter();
    @Output() hasError: EventEmitter<boolean> = new EventEmitter();
    @Output() intlTelInputObject: EventEmitter<any> = new EventEmitter();
    @Output() intlTelOutput: EventEmitter<string> = new EventEmitter();

    intlTelInput: any;

    constructor(
        private elementRef: ElementRef,
        @Inject(PLATFORM_ID) private platformId: string,
    ) {}

    @HostListener('blur') onBlur(): void {
        const isInputValid: boolean = this.isInputValid();
        if (isInputValid) {
            const telOutput = this.intlTelInput.getNumber();
            this.hasError.emit(isInputValid);
            this.intlTelOutput.emit(telOutput);
        } else {
            this.hasError.emit(isInputValid);
        }
    }

    async ngOnInit(): Promise<void> {
        if (isPlatformBrowser(this.platformId)) {
            const module = await import('intl-tel-input/intlTelInputWithUtils');
            const intlTelInput = module.default;
            this.intlTelInputOptions = {
                ...this.intlTelInputOptions,
            };
            this.intlTelInput = intlTelInput(this.elementRef.nativeElement, {
                ...this.intlTelInputOptions,
            });

            this.elementRef.nativeElement.addEventListener('countrychange', () => {
                this.countryChange.emit(this.intlTelInput.getSelectedCountryData());
            });

            this.intlTelInputObject.emit(this.intlTelInput);
        }
    }

    isInputValid(): boolean {
        return this.intlTelInput.isValidNumber();
    }
}
